module.exports = __webpack_public_path__ + "static/media/icon-bulb-blue.522d8146.png";